import styled from 'styled-components';

export const DownloadWrapper = styled.div`
  max-width: 1140px;
  text-align: center;
  font-size: 24px;
  font-family: ${({ theme }) => theme.basic.fontWeights.regular};
`;
